<template>
  <p-card :padding="padding"
          class="contact"
          title="Contactgegevens"
          has-button
          icon-name="pencil"
          icon-size="large"
          :rounded="false"
          title-size="lg"
          @button-click="emit('edit-contact')">
    <template #content>
      <p-table class="contact__table"
               :columns="columns"
               :rows="rows"
               :omit-header="true"
               :colgroup="[{ span: 1, width: '180px' }]"
               compact
               disable-horizontal-spacing>
        <template #row_type="row">
          <span class="contact__type--bold">{{ row.value.type }}</span>
        </template>
        <template #row_value="row">
          <span class="contact__value">{{ row.value.value || '-' }}</span>
        </template>
      </p-table>
    </template>
  </p-card>
</template>
<script lang="ts" setup>
import { useUserStore } from '@pidz/stores';
import { computed } from 'vue';

const props = defineProps<{
  data: ProfileContact;
  padding: string;
}>();

const emit = defineEmits(['edit-contact']);
const userStore = useUserStore();

const columns = [
  { field: 'type', label: 'type' },
  { field: 'value', label: 'waarde' },
];

const rows = computed(() => [
  {
    type: 'Email',
    value: props.data.email,
  },
  {
    type: 'Mobiel nr.',
    value: props.data.mobile,
  },
  {
    type: 'Telefoon nr.',
    value: props.data.phone,
  },
  ...userStore.isUserAgencyWorker ? [{
    type: 'Noodcontact',
    value: props.data.emergencyContact,
  }] : [],
  ...userStore.isUserAgencyWorker ? [{
    type: 'Noodcontact nr.',
    value: props.data.emergencyPhone,
  }] : [],
]);
</script>
<style scoped lang="scss">
.contact {
  &__table {
    margin-top: 24px;
    font-size: 16px;
  }
  &__type {
    &--bold {
      font-weight: bold;
      font-size: 14px;
    }
  }
}
</style>
